export interface IProvider {
	name: string,
    iconUrl: string,
}

export enum ManagementType {
    external = "external",
    local = "local"
}